function initSimpleCollapse() {

	$('.simple-collapse').each((index, collapse) => {
		const $collapse = $(collapse);
		const $trigger = $collapse.find('.simple-collapse-trigger');
		const $opener = $collapse.find('.simple-collapse-opener');
		const $closer = $collapse.find('.simple-collapse-closer');
		const $content = $collapse.find('.simple-collapse-content');

		$trigger.on('click', () => {
			if($collapse.hasClass('active')) {
				$collapse.removeClass('active');
				$opener.css("display", "block");
				$closer.css("display", "none");
				$content.slideUp();
			} else {
				$collapse.addClass('active');
				$opener.css("display", "none");
				$closer.css("display", "block");
				$content.slideDown();
			}
		});
	});

}

export default initSimpleCollapse;